import { api } from '@/modules/apiv2';

export default {
  state: {
    connection: null,
    connections: [],
    pairingCode: null,
    connectedOwners: [],
  },

  getters: {
    connection(state) {
      return state.connection;
    },

    connections(state) {
      return state.connections;
    },

    pairingCode(state) {
      return state.pairingCode;
    },

    connectedOwners(state) {
      return state.connectedOwners;
    },
  },

  mutations: {
    setConnection(state, connection) {
      state.connection = connection;
    },

    setConnections(state, connections) {
      state.connections = connections;
    },

    setPairingCode(state, pairingCode) {
      state.pairingCode = pairingCode;
    },

    setConnectedOwners(state, connectedOwners) {
      state.connectedOwners = connectedOwners;
    },
  },

  actions: {
    getConnection({ commit, getters }, connectionId) {
      const endpoint = getters.connectionsEndpoint;

      return api
        .get(`${endpoint}/${connectionId}`)
        .then((data) => {
          commit('setConnection', data);
          return data;
        })
        .catch((error) => {
          throw error;
        });
    },

    getConnections({ commit, getters }) {
      const endpoint = getters.connectionsEndpoint;

      return api
        .get(endpoint)
        .then((data) => {
          commit('setConnections', data);
          return data;
        })
        .catch((error) => {
          throw error;
        });
    },

    createConnection({ commit, getters }, data) {
      const endpoint = getters.connectionsEndpoint;
      const currentUserName = getters.currentUser.account.idTokenClaims.extension_CosmosDbAccountId;

      return api
        .post(`${endpoint}?pairingCode=${data.PairingCode}&updatedBy=${currentUserName}`)
        .then((data) => {
          commit('setConnection', data.connection);
          return data.connection;
        })
        .catch((error) => {
          throw error;
        });
    },

    updateConnection({ commit, getters }, data) {
      const endpoint = getters.connectionsEndpoint;
      const orgType = getters.currentUserIsOwner ? 'owner' : 'consumer';

      return api
        .put(`${endpoint}/${data.id}/${orgType}details`, data)
        .then((data) => {
          commit('setConnection', data.connection);
          return data.connection;
        })
        .catch((error) => {
          throw error;
        });
    },

    deleteConnection({ commit, getters }, connectionId) {
      const endpoint = getters.connectionsEndpoint;

      return api
        .delete(`${endpoint}/${connectionId}`)
        .then(() => {
          commit('setConnection', null);
          return;
        })
        .catch((error) => {
          throw error;
        });
    },

    getPairingCode({ commit, getters }) {
      const endpoint = getters.pairingCodeEndpoint;

      return api
        .get(endpoint)
        .then((data) => {
          commit('setPairingCode', data);
          return data;
        })
        .catch((error) => {
          throw error;
        });
    },

    async getConnectedOwners({ commit, dispatch }) {
      let owners = [];
      // get all Accepted connections
      let connections = (await dispatch('getConnections')).filter((c) => c.Status == 'Accepted');

      // for each connection, get devices
      for (let connection of connections) {
        let devices = await dispatch('getConnectionDevices', connection.id);
        owners.push({
          config: {
            id: connection.OwnerConnectionDetails.OrganizationId,
            Name: connection.OwnerConnectionDetails.OrganizationName,
          },
          devices: devices,
        });
      }
      commit('setConnectedOwners', owners);
    },
  },
};
